import { useContext } from "react";
import { TriggeredHook } from "sonobello.utilities.react";

import AppContext from "../../../../AppContext";
import AppointmentNoteContentBuilder, {
  AppointmentNoteTagProps
} from "../../../Notes/Compositions/AppointmentNoteContentBuilder";
import IReservation from "../../../Types/IReservation";
import { IConfirmedAppointmentResponse } from "../Hooks/UseConfirmAppointment";
import useConfirmAppointment from "../Hooks/UseConfirmAppointment";
import useCreateContactResult from "../Hooks/UseCreateContactResult";

/** A composed hook used to confirm an appointment. */
const AppContextUseConfirmAppointment: TriggeredHook<IConfirmedAppointmentResponse, IReservation, boolean> = () => {
  const { defaultCenter, patient, contactId, medicalConclusions, reservation } = useContext(AppContext);
  return useConfirmAppointment({
    useCreateContactResult,
    noteProps: {
      patient: patient,
      medicalConclusions,
      reservation: reservation!,
      center: defaultCenter
    } as AppointmentNoteTagProps,
    noteContentBuilder: AppointmentNoteContentBuilder,
    patient: patient,
    contactId: contactId
  });
};

export default AppContextUseConfirmAppointment;
